import "./about.css"
import React from "react"
import { Skills } from "../Skills/Skills"

export const About = () => {
  return (
    <div id="about" className="about-container">
      <Skills />
    </div>
  );
}